module.exports = __webpack_public_path__ + "img/clickandbuy-logo.b90e4313.svg";